import {
  ALL_COUNTRIES,
  BROKER_HEIGHTENED_RESTRICTION_COUNTRIES_OPTIONS,
  CITIZENSHIP_COUNTRY_OPTIONS,
  RESTRICTED_COUNTRIES_OPTIONS,
  UK_COUNTRY_CODE,
  USA_COUNTRY_CODE,
  pushElementToFront,
  sortCountriesByLabel,
} from "@tastyworks/tastyworks-api"

export function isForeigner(country: string | undefined) {
  return country !== USA_COUNTRY_CODE
}

// matching logic from twapi-ember
export const CITIZENSHIP_COUNTRIES = sortCountriesByLabel(
  CITIZENSHIP_COUNTRY_OPTIONS.filter(
    (country) =>
      !BROKER_HEIGHTENED_RESTRICTION_COUNTRIES_OPTIONS.includes(country)
  )
)
export const FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES = sortCountriesByLabel(
  CITIZENSHIP_COUNTRY_OPTIONS.filter(
    (country) => !RESTRICTED_COUNTRIES_OPTIONS.has(country)
  )
)

export const ALL_COUNTRIES_WITH_USA_FIRST = pushElementToFront(
  sortCountriesByLabel(ALL_COUNTRIES),
  USA_COUNTRY_CODE
)

if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("isForeigner", () => {
    it("returns true when the country is not USA", () => {
      expect(isForeigner(UK_COUNTRY_CODE)).toBe(true)
    })

    it("returns false when the country is USA", () => {
      expect(isForeigner(USA_COUNTRY_CODE)).toBe(false)
    })
  })

  describe("CITIZENSHIP_COUNTRIES", () => {
    it("includes the USA but removes broker heightened restricted countries", () => {
      expect(CITIZENSHIP_COUNTRIES.length).toBe(247)
      expect(CITIZENSHIP_COUNTRIES.includes(USA_COUNTRY_CODE)).toBe(true)
      expect(CITIZENSHIP_COUNTRIES.includes("RUS")).toBe(false)
    })
  })

  describe("FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES", () => {
    it("removes all restricted countries from the list", () => {
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("RUS")).toBe(false)
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("AGO")).toBe(false)
      expect(FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes("TJK")).toBe(false)
      expect(
        FOREIGN_ACCOUNT_CITIZENSHIP_COUNTRIES.includes(USA_COUNTRY_CODE)
      ).toBe(true)
    })
  })

  describe("ALL_COUNTRIES_WITH_USA_FIRST", () => {
    it("orders the countries and puts the USA at the start of the list", () => {
      expect(ALL_COUNTRIES_WITH_USA_FIRST.length).toBe(248)
      expect(ALL_COUNTRIES_WITH_USA_FIRST[0]).toBe(USA_COUNTRY_CODE)
    })
  })
}
